import React from 'react';
import WebsitePage from './WebsitePage';

const ServicesPage = () => <WebsitePage slug="services" />;
export default ServicesPage;
